import TapaComponent from "./TapaComponent";

export default class TapaValue extends TapaComponent {
  constructor(name, lowerBound, upperBound, unit) {
    //Vars
    super(name, []);
    this._lowerBound = lowerBound;
    this._upperBound = upperBound;
    this._unit = unit;

    //Methods
    this.prng = this.prng.bind(this);

    //Init
    this.setup.call(this);
  }

  //Getters and Setters
  //Lower Bound
  get lowerBound() {
    return this._lowerBound;
  }
  set lowerBound(newLowerBound) {
    this._lowerBound = newLowerBound;
  }

  //Upper Bound
  get upperBound() {
    return this._upperBound;
  }
  set upperBound(newUpperBound) {
    this._upperBound = newUpperBound;
  }

  //Methods
  prng() {
    return (
      Math.floor(Math.random() * (this._upperBound - this._lowerBound)) +
      this._lowerBound
    );
  }

  setup() {
    let component = new TapaComponent("output", []);

    const value = this.prng();

    component.children.push({
      valueDisplay: `${value} ${this._unit}`,
      value: value
    });

    this._children["output"] = component;
  }
}



// WEBPACK FOOTER //
// ./src/lib/TapaValue.js